import React from 'react';
import { SelectField, TextField } from 'react-admin';
// import PropTypes from 'prop-types';
import EjectedDatagrid from '../../../components/ejected/Datagrid';
import TextFieldWithDate from '../../../components/TextFieldWithDate';
import OSField from '../../../components/OSField';
import CompanyName from '../../../components/CompanyName';

import BrowserField from '../../../components/BrowserField';


const rowStyle = (record, rowId) => {
  let backgroundColor = '#FFF';
  // const now = new Date();
  const time = new Date(record['_createdAt']);
  const hours = time.getHours();
  if (hours > 21 || hours < 9) {
    backgroundColor = '#fff0f0';
    // if (record.visited === 'new') {
    //   backgroundColor = '#fff0f0';
    // }
  }
  return { backgroundColor };
};


const Datagrid = ({
  create, edit, total, companies, callcenters, roles, users, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC' }}
    create={create}
    edit={edit}
    rowStyle={rowStyle}
    {...rest}
  >
    <TextField source="userName" label="Имя" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} />
    <SelectField source="userRole" label="Должность" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} choices={roles} />
    <TextField source="action" label="Действие" customstyles={{ width: '150px', backgroundColor: '#2c9bc3' }} />
    <CompanyName label="Компания" customstyles={{ width: '100px', backgroundColor: '#2c9bc3' }} users={users} companies={companies} callcenters={callcenters} />
    <TextField source="ip" label="IP" customstyles={{ width: '110px', backgroundColor: '#2c9bc3' }} />
    <OSField source="osV" label="ОС" customstyles={{ width: '80px', backgroundColor: '#2c9bc3' }} />
    <BrowserField source="browserV" label="Браузер" customstyles={{ width: '80px', backgroundColor: '#2c9bc3' }} />
    <TextFieldWithDate source="_createdAt" costilniiKostil label="Дата" customstyles={{ textAlign: 'left', width: '100px', backgroundColor: '#2c9bc3' }} />
  </EjectedDatagrid>
);

// Datagrid.defaultProps = {
//   edit: null,
//   create: null,
//   companies: [],
//   callcenters: [],
//   roles: []
// };
//
// Datagrid.propTypes = {
//   edit: PropTypes.func,
//   create: PropTypes.func,
//   companies: PropTypes.arrayOf(PropTypes.shape({
//     id: PropTypes.string.isRequired,
//     name: PropTypes.string.isRequired
//   })),
//   callcenters: PropTypes.arrayOf(PropTypes.shape({
//     id: PropTypes.string.isRequired,
//     name: PropTypes.string.isRequired
//   })),
//   roles: PropTypes.arrayOf(PropTypes.shape({
//     id: PropTypes.string.isRequired,
//     name: PropTypes.string.isRequired
//   }))
// };

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/admin/requestlog/Datagrid.js